import { extractYoutubeId } from './extractYoutubeId';
export function proxyEmbedUrl(baseUrl, url, options) {
    const id = extractYoutubeId(url);
    if (id == null) return null;
    const params = new URLSearchParams({
        v: id,
        controls: options.controls === false ? '0' : '1',
        playsinline: '1'
    });
    if (options.autoplay) params.set('autoplay', '1');
    if (options.mute) params.set('mute', '1');
    return "".concat(baseUrl, "/youtube-embed.html?").concat(params.toString());
}
